
function lightningShopCategory()
{
    var category_buttons    = document.querySelectorAll( '.category_button' );

    category_buttons.forEach( ( category_button ) =>
    {   
        category_button.addEventListener( "click", HandleCategoryClick );
    } );
}

function HandleCategoryClick( e )
{
    var clickedBtn          = e.currentTarget;
    var allitems            = document.querySelectorAll( ".lightning_category_item_slider" );
    var category_buttons    = document.querySelectorAll( '.category_button' );
    var isActive            = clickedBtn.classList.contains( "active" );
    var scrollright         = document.querySelector( ".scrollright" )
    var scrollleft          = document.querySelector( ".scrollleft" )

    scrollright.classList.add( "hidden" ); 
    scrollleft.classList.add( "hidden" ); 
     
    category_buttons.forEach( ( button ) =>
    {   
        button.classList.remove( "active" );
    } );

    allitems.forEach(( item ) =>
    {   
        item.classList.remove( "active" );
        item.classList.add( "hidden" );
    } );

    if( !isActive )
    {
        clickedBtn.classList.add( "active" );
        var sliderEl        = ".lightning_category_item_slider"+'.'+ clickedBtn.dataset.title;         
        document.querySelector( sliderEl  ).classList.add( "active" );
        document.querySelector( sliderEl  ).classList.remove( "hidden" );

        var scrollableitem  = document.querySelector( sliderEl+'.active' );     
        initializeScrolling( scrollableitem );
    }
}

function updateArrowsVisibility( scrollableitem, scrollRightButton, scrollLeftButton)
{
    var horizontalScrollbar   = scrollableitem.scrollWidth > scrollableitem.clientWidth;

    console.log(Math.round(scrollableitem.scrollLeft));
    console.log(scrollableitem.scrollWidth);
    console.log(scrollableitem.clientWidth);

    if ( scrollableitem.scrollLeft > 0 ) 
    {
        scrollLeftButton.classList.remove( "hidden" );
    } 
    else 
    {
        scrollLeftButton.classList.add( "hidden" );
    }

    if ( horizontalScrollbar && ( Math.round(scrollableitem.scrollLeft) == ( scrollableitem.scrollWidth - scrollableitem.clientWidth ))) 
    {
        scrollRightButton.classList.add( "hidden" );
    } 
    else 
    {
        scrollRightButton.classList.remove( "hidden" );
    }

    if( scrollableitem.scrollWidth == scrollableitem.clientWidth )
    {
        scrollRightButton.classList.add( "hidden" );
        scrollLeftButton.classList.add( "hidden" );
    }
}

function initializeScrolling( scrollableitem ) 
{
  
    if ( scrollableitem ) 
    {
        var scrollRightButton   = document.querySelector( ".scrollright" );
        var scrollLeftButton    = document.querySelector( ".scrollleft" );
         
        updateArrowsVisibility( scrollableitem, scrollRightButton, scrollLeftButton );
        scrollRightButton.addEventListener( "click", function () 
        {
            scrollableitem.scrollLeft += 300;
            updateArrowsVisibility( scrollableitem, scrollRightButton, scrollLeftButton );
        } );

        scrollLeftButton.addEventListener( "click", function () 
        {
            scrollableitem.scrollLeft -= 300;
            updateArrowsVisibility( scrollableitem, scrollRightButton, scrollLeftButton );
        } );
        
        scrollableitem.addEventListener( "scroll", function() 
        {
            updateArrowsVisibility( scrollableitem, scrollRightButton, scrollLeftButton );
        } );
    }
  }

function selecteinput() 
{
	var allinput = document.querySelectorAll( ".lightning_category_item input" );
	allinput.forEach( ( input ) =>
	{	
		input.addEventListener( "change", function(e)
		{
            input.parentNode.classList.toggle( 'selected' );
		} );
	} );
}

window.addEventListener( "DOMContentLoaded", function(e)
{
    lightningShopCategory();
    selecteinput();
});